import { render, staticRenderFns } from "./Article8.vue?vue&type=template&id=b7484c06&"
import script from "./Article8.vue?vue&type=script&lang=js&"
export * from "./Article8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports